import { Flex, useColorModeValue } from "@chakra-ui/react"

export default function QuickStartGuide() {
    return (
        <Flex
            h={"100vh"}
            justify={"center"}
            align={"center"}
            bg={useColorModeValue("gray.50", "gray.800")}
            p={"2rem"}
        >
            <iframe
                src="/Quick_Start_Guide.pdf#view=Fit"
                style={{
                    border: "none",
                    borderRadius: "8px",
                    width: "50%",
                    height: "90vh",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.15)"
                }}
            />
        </Flex>
    )
}